window.addEventListener("DOMContentLoaded", () => {
  const wrappers = document.querySelectorAll(".cus-reviews__wrapper");
  
  wrappers.forEach(wrapper => {
    
    if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      addAnimation();
    }
    
    function addAnimation() {
        const container = wrapper.querySelector(".cus-reviews");
        container.setAttribute("data-animated", true);
    
        const containerInner = container.querySelector(".reviews-list");

        console.log(container);
        const containerContent = Array.from(containerInner.children);
    
        containerContent.forEach((item) => {
          const duplicatedItem = item.cloneNode(true);
          duplicatedItem.setAttribute("aria-hidden", true);
          containerInner.appendChild(duplicatedItem);
        });
    }
  })
  
})
